import React, { useEffect } from "react";
import UniversalIcon from "../Assets/Images/universal-menu-icon.svg";
import TermLifeIcon from "../Assets/Images/termlife-icon.svg";
import IndexUniversalIcon from "../Assets/Images/index-universal-icon.svg";
import CriticalMenuIcon from "../Assets/Images/critical-illness-menuIcon.svg";
import CompareSearchImage from "../Assets/Images/compareProductImage.svg";
import "../Assets/Styles/NavBar.css"; // Make sure the CSS file is correctly imported
import { Link } from "react-router-dom";
import { useTranslation } from "../Hooks/useTranslation";

const ProductsModal = ({ isOpen, isScrolled, onClose }) => {
  const translations = useTranslation();
  const { navbar: navbarLang } = translations;

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-30 ${
        isOpen ? "modal-overlay active" : "modal-overlay"
      } flex justify-center `}
    >
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/20 " onClick={onClose} />

      {/* Modal Content */}
      <div
        className={`relative overflow-hidden bg-white w-full shadow-lg transition-transform transform modal-slide ${
          isOpen ? "active" : ""
        } lg:h-[350px] ${
          isScrolled ? "mt-[72px]" : "mt-[122px]"
        } pt-[0px]  `}
      >
        <div className="container h-[100%] flex max-w-full lg:max-w-full [@media(min-width:1920px)]:max-w-[1800px] mx-auto">
          {/* Left Column - Our Plans */}
          <div className="ourplansdiv flex justify-center items-center w-3/5 xl:p-16 lg:p-6 lg:pb-0 [@media(min-width:1920px)]:pl-[4px]">
            <div className="flex justify-center items-center w-full">
              <div className="w-3/5">
                <Link to="/universal-life-insurance">
                  <div className="group cursor-pointer mt-[3rem] mb-[3rem]">
                    <div className="flex items-center space-x-4">
                      <img className="AFIcons" src={UniversalIcon} alt="" />
                      <div>
                        <div className="flex items-center space-x-2">
                          <span className="Aftexts font-medium">
                            <Link to="/universal-life-insurance">
                              {navbarLang.productSub.universalLifeInsurance ||
                                "Universal Life Insurance"}
                            </Link>
                          </span>
                          <svg
                            className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M5 12h14m-7-7l7 7-7 7"
                              stroke="currentColor"
                              fill="none"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <p className="text-[#565454] text-[14px]">
                          Prime and Ultra III{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to="/indexed-universal-life-insurance">
                  <div className="group cursor-pointer mt-[3rem] mb-[3rem] ">
                    <div className="flex items-center space-x-4">
                      <img
                        className="AFIcons"
                        src={IndexUniversalIcon}
                        alt=""
                      />
                      <div className="flex items-center space-x-2">
                        <span className="Aftexts font-medium">
                          <Link to="/indexed-universal-life-insurance">
                            {navbarLang.productSub.indexedUniversal}
                          </Link>
                        </span>
                        <svg
                          className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M5 12h14m-7-7l7 7-7 7"
                            stroke="currentColor"
                            fill="none"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="w-2/5">
                <Link to="/term-life-insurance">
                  <div className="group cursor-pointer mt-[3rem] mb-[3rem]">
                    <div className="flex items-center space-x-4">
                      <img className="AFIcons" src={TermLifeIcon} alt="" />
                      <div className="flex items-center space-x-2">
                        <span className=" Aftexts font-medium">
                          <Link to="/term-life-insurance">
                            {navbarLang.productSub.termLifeInsurance}
                          </Link>
                        </span>
                        <svg
                          className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M5 12h14m-7-7l7 7-7 7"
                            stroke="currentColor"
                            fill="none"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </Link>

                <Link to="/critical-illness-insurance">
                  <div className="group cursor-pointer mt-[3rem] mb-[3rem]">
                    <div className="flex items-center space-x-4">
                      <img className="AFIcons" src={CriticalMenuIcon} alt="" />
                      <div className="flex items-center space-x-2">
                        <span className="Aftexts font-medium">
                          <Link to="/critical-illness-insurance">
                            {navbarLang.productSub.criticalIllnessInsurance}
                          </Link>
                        </span>
                        <svg
                          className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M5 12h14m-7-7l7 7-7 7"
                            stroke="currentColor"
                            fill="none"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          {/* Right Column - Insights */}
          <div className="rightcolmaindiv bg-[#F7F6F2] pt-8 [@media(min-width:1920px)]:pt-16 pb-0 flex justify-center [@media(min-width:1920px)]:justify-start items-end [@media(min-width:1920px)]:items-start w-2/5">
            <div className="pl-12 pr-12 [@media(min-width:1920px)]:pl-6 [@media(min-width:1920px)]:pr-6">
              <div className="flex flex-col  ">
                <h3 className="text-gray-500 font-medium">
                  <Link
                    to="/compare-plans"
                    className="flex flex-row items-center  text-[#0D4248] font-bold text-[20px] leading-[22px]"
                  >
                    {navbarLang.productSub.compareProduct}
                    <svg
                      className="w-4 h-4 transform group-hover:translate-x-1 transition-transform ml-2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7-7 7"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                </h3>
                <p className="text-[#0D4248] mt-2 discovertext relative">
                  {navbarLang.productSub.compareDesc}
                </p>
                <img
                  className="w-[100%] self-center [@media(min-width:1920px)]:max-h-[200px] [@media(min-width:1920px)]:object-contain"
                  src={CompareSearchImage}
                  alt="Health Plan Comparison"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsModal;
